import { ref, watch } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

export function useSalesTransactionDetail({ id, t }) {
  const error = ref('');
  const loading = ref(false);
  const transaction = ref(null);
  let requestSequence = 0;

  const load = async transactionId => {
    requestSequence += 1;
    const sequence = requestSequence;
    transaction.value = null;
    error.value = '';

    if (!transactionId) return null;

    loading.value = true;
    try {
      const { data } = await SalesTransactionsAPI.show(transactionId);
      if (sequence !== requestSequence) return null;

      transaction.value = data;
      return data;
    } catch (requestError) {
      if (sequence !== requestSequence) return null;

      error.value =
        requestError?.response?.data?.message ||
        requestError?.response?.data?.error ||
        t('REAL_ESTATE_FINANCE.SALE_DETAIL.ERROR');
      return null;
    } finally {
      if (sequence === requestSequence) loading.value = false;
    }
  };

  watch(id, load, { immediate: true });

  return { error, load, loading, transaction };
}
